import React from 'react'

export default class Footer extends React.Component {

    render() {

        return (
            <footer>
                <p>ShopList Footer</p>
            </footer>
        )
    }
}